import { useQueryClient } from "@tanstack/react-query";
import { editPropertyPrice } from "../api";
import { EditPropertyPriceDTO } from "../dtos";
import { PropertyPrice } from "../types";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";


export function useEditPropertyPrice() {
  const queryClient = useQueryClient();

  const mutationEditPropertyPrice = useDomainMutation<
    PropertyPrice,
    { response?: { data?: { message?: string } } },
    { uid?: string; data: EditPropertyPriceDTO }
  >({
    mutationFn: ({
      uid,
      data,
    }: {
      uid?: string;
      data: EditPropertyPriceDTO;
    }) => {
      return editPropertyPrice(uid ?? "", data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["track"] });
    },
  });

  return mutationEditPropertyPrice;
}
